var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.12163 8L11.1375 8.5L10.6362 11L8.63089 12.5L5.62295 13.5L2.61501 11L5.12163 8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1452 5.67444H8.45598V4.20447e-05C9.96677 -0.00576537 11.4171 0.590251 12.4856 1.65557C13.5536 2.72104 14.151 4.16746 14.1452 5.67444ZM6.6987 1.75275V7.42715H12.3879C12.3879 7.57172 12.4098 7.71629 12.4098 7.86528C12.4098 9.49225 11.7618 11.0526 10.6084 12.2032C9.4549 13.3535 7.8905 14 6.2591 14C4.62789 14 3.06348 13.3536 1.90984 12.2032C0.75655 11.0528 0.108398 9.49245 0.108398 7.86528C0.108398 6.23832 0.756511 4.67798 1.90984 3.52733C3.06329 2.37688 4.62769 1.73057 6.2591 1.73057C6.40849 1.73057 6.55376 1.7419 6.6987 1.75275ZM6.18466 9.1797L3.83207 11.5175C4.9823 12.2755 6.42244 12.451 7.72192 11.9917C9.02125 11.5323 10.0291 10.4911 10.4438 9.1797H6.18466Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMeasure);
export default __webpack_public_path__ + "static/media/headerMeasure.72fd02d351dcfe4aaa981375c935ac37.svg";
export { ForwardRef as ReactComponent };